export const davidLloydLogoImage: Queries.ImageDetails = {
  imagePath: '/fixed-images/david-lloyd-logo.svg',
  alternateText: 'The David Lloyd Clubs logo',
  horizontalFocus: 'center',
  leftHighlight: false,
};

export const harbourLogoImage: Queries.ImageDetails = {
  imagePath: '/fixed-images/harbour-logo.png',
  alternateText: 'Harbour club logo',
  horizontalFocus: 'center',
  leftHighlight: false,
};

export const togetherFoundationLogoImage: Queries.ImageDetails = {
  imagePath: '/fixed-images/together-foundation-logo-black.png',
  alternateText: 'Together Foundation logo',
  horizontalFocus: 'center',
  leftHighlight: false,
};

export const whiteHarbourLogoImage: Queries.ImageDetails = {
  imagePath: '/fixed-images/white-harbour-logo.png',
  alternateText: 'Harbour club logo',
  horizontalFocus: 'center',
  leftHighlight: false,
};

export const darkBgMeridianLogoImage: Queries.ImageDetails = {
  imagePath: '/fixed-images/meridian-logo-dark-bg.png',
  alternateText: 'Meridian club logo',
  horizontalFocus: 'center',
  leftHighlight: false,
};

export const lightBgBlackMeridianLogoImage: Queries.ImageDetails = {
  imagePath: '/fixed-images/meridian-logo-black.png',
  alternateText: 'Meridian club logo',
  horizontalFocus: 'center',
  leftHighlight: false,
};
